import { useState } from "react";
import type { TabsConfig } from "~components/DataTable/types/tabsConfig.ts";

export const useDataTableTabs = <T>(tabsConfig?: TabsConfig<T>) => {
  const [innerActiveKey, setInnerActiveKey] = useState<string>();
  const items = tabsConfig?.items ?? [];
  const requestedKey = tabsConfig?.activeKey ?? innerActiveKey;

  // Items may change (e.g. after refetch), so fall back to the first tab when the requested one is gone
  const activeTab = items.find((item) => item.key === requestedKey) ?? items[0];

  const changeTab = (key: string) => {
    setInnerActiveKey(key);
    tabsConfig?.onChange?.(key);
  };

  return { tabs: items, activeTab, changeTab };
};
